import { graphql, HttpResponse } from 'msw'
import { type EnrollmentMultiWireTransferData, type EnrollmentMultiWireTransferAccountData } from '../../../../models'

// Mock for getEnrollmentMultiWireTransferAccountData (returns account data)
export const getEnrollmentMultiWireTransferAccountDataMock: EnrollmentMultiWireTransferAccountData = {
  highYieldChecking: {
    accounts: [
      {
        routingNumber: '125109019',
        accountNumber: '314896161',
      },
    ],
  },
}

// Mock for getEnrollmentMultiWireTransferData (returns enrollment data)
export const getEnrollmentMultiWireTransferDataMock: EnrollmentMultiWireTransferData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/funding/wire-transfer',
  enrollmentData: {
    applicationId: '1234567890',
    firstName: 'Nick',
    lastName: 'Navarro',
    addressLine1: '1905 Bellevue Way',
    addressLine2: 'Apt 101',
    addressCity: 'Tallahassee',
    addressPostalCode: '32304',
    addressRegionCode: 'FL',
    addressCountry: 'US',
  },
}

// Mock for getEnrollmentMultiWireTransferAccountData (query)
export const mockGetEnrollmentMultiWireTransferAccountData = graphql.query('getEnrollmentMultiWireTransferData', () => {
  return HttpResponse.json({
    data: {
      wealthOverview: getEnrollmentMultiWireTransferAccountDataMock,
    },
  })
})

// Mock for getEnrollmentMultiWireTransferData (mutation)
export const mockGetEnrollmentMultiWireTransferData = graphql.mutation('getEnrollmentMultiWireTransferData', () => {
  return HttpResponse.json({
    data: {
      submitEnrollment: getEnrollmentMultiWireTransferDataMock,
    },
  })
})

export const mockEnrollmentMultiWireTransfer = [
  mockGetEnrollmentMultiWireTransferAccountData,
  mockGetEnrollmentMultiWireTransferData,
]
